module.exports = __webpack_public_path__ + "img/image-02.02aeeb13.png";